$(document).ready(function(){
  $('.owl-dots-replicated .owl-dot:not(.active)').click(function(){
      theDot = $(this).attr('data-dot')
      parentEle = $(this).closest('.owl-carousel')
      $(parentEle).find('.owl-dots > .owl-dot:nth-child(' + theDot + ')').click()
  })
  var owl = $('.owl-carousel');
  owl.owlCarousel({
      loop:true,
      autoplay:true,
      autoplayTimeout:8000,
      autoplayHoverPause:true
  });
  if($('.pet-single-outer').length) {
    $(".pet-button-row .pet-single-outer").sort(sort_ele_pet_rows) // sort elements
                      .appendTo('.pet-button-row'); // append again to the list
  	function sort_ele_pet_rows(a, b){
		return ($(b).data('pet-title')) < ($(a).data('pet-title')) ? 1 : -1;
  	}
  }
  if($('.pet-selector-inner').length) {
    $(".pet-selector-inner .pet-option-single").sort(sort_ele_pet_dropdown) // sort elements
                      .appendTo('.pet-selector-inner'); // append again to the list
  	function sort_ele_pet_dropdown(a, b){
		return ($(b).data('url')) < ($(a).data('url')) ? 1 : -1;
  	}
  }
  $('.dropdown-button-mobile .menu-button').click(function(){
    $(this).parent().toggleClass('active')
    if($(this).parent().hasClass('active')) {
      $(this).parent().find('.mobile-dropdown').slideDown()
    } else {
      $(this).parent().find('.mobile-dropdown').slideUp()
    }
  })
  $('body').on('click','.bv_stars_component_container',function(){
      $('.tab-single[data-tab-handle="reviews"]').click()
      $('html, body').animate({
        scrollTop: $('.tabs-header-inner').offset().top,
      },750)
  })
  if(getQueryVariable('variant')) {
    setTimeout(function(){
      $('.product__thumb[data-id="' + getQueryVariable('variant') + '"]').click()
    },1000)

  }
  $('.show-all-imgs').click(function(){
    $('.product__thumb-item').show()
  })
  if(typeof currentVariant !== 'undefined' && $('.product__thumb-item.main').length == 0) {
    $('.product__thumb-item:not([data-variant_id="' + currentVariant + '"])').hide()
  }
  $('.faux-link').click(function(e){
    e.stopPropagation()
    href= $(this).data('href')
    console.log(href)
    window.location.href = href
  })
  lazyload();
  $('#store-locator-title').after('<p class="store-locator-subtext" style="font-style:italic">Please contact your location of choice to confirm availability. We cannot guarantee every style is available in store. </p>')
  $(window).resize(function(){
    $('.maintain-aspect-ratio:visible').height($('.maintain-aspect-ratio:visible').width() / ($('.maintain-aspect-ratio:visible').attr('width') / $('.maintain-aspect-ratio:visible').attr('height')))
  })
  $(window).trigger('scroll')
  
  // Get some scrolling functionality going.
  $(window).scroll(function(){
    var screenBottom = window.scrollY + window.innerHeight
    var screenTop = window.scrollY

    // Reset video on scroll
    if($("#Mp4Video-1565286837865").length) {
      videoId        = "#Mp4Video-1565286837865"
      triggeredClass = "triggeredPlay"
      videoEle       = $(videoId);
      eleBottom      = videoEle.position().top + videoEle.outerHeight(true);
      eleBottom      = videoEle.offset().top   + videoEle.outerHeight(true);
      eleTop         = videoEle.offset().top
      vid            = document.getElementById("Mp4Video-1565286837865");

      if((screenBottom > eleBottom) && (screenTop < eleTop)) {
        if(!$(videoId).hasClass(triggeredClass)) {
          vid.currentTime = 0;
          vid.load();
          vid.play();
        }
        $(videoId).addClass(triggeredClass)
      } else {
        $(videoId).removeClass(triggeredClass)
      }
    }
    
    eles = [
      '.technology-list-left .tech-img-before',
      '.technology-list-left .tech-img-after',
      '.technology-list-right .tech-img-before',
      '.technology-list-right .tech-img-after',
      '.top-okocat-icons'
    ]
    
    // Scrolling in technology background items
    $.each(eles,function(key,val){
      if($(val).length) {
        modifier = 0
        if($(val).hasClass('tech-img-after')) modifier = 200
        bottom = $(val).offset().top + $(val).outerHeight(true) - modifier;
        isBefore = val.includes('before')
        if(screenBottom > bottom) {
          $(val).addClass('scrolled-in')
        }
      }
    })
    elesHalf = [
      '.microscope-outer-container',
      '.img-w-zoom-circle-pan-zoom',
      '.litter-rev-row.video-outer'
    ]
    $.each(elesHalf,function(key,val){
      if($(val).length) {
        modifier = 200
        bottom = $(val).offset().top + $(val).outerHeight(true) - modifier;
        isBefore = val.includes('before')
        if(screenBottom > bottom) {
          $(val).addClass('scrolled-in')
        }
      }
    })
    
    // Animate.css functionality
    if($('.animation-ele').length) {
      $('.animation-ele').each(function(key,val){
        var el = $(this);
        var bottom = el.position().top + el.outerHeight(true);
        scrollAdvance = 0
        if($(val).hasClass('complete-comfort')) scrollAdvance = 300
        var bottom = el.offset().top + el.outerHeight(true) - scrollAdvance
        if(screenBottom > bottom) {
          animationType = ($(this).attr('data-animation')) ? $(this).attr('data-animation') : 'bounceInRight'
          $(this).addClass(animationType + ' animated')
        }
      })
    }
    
    // Animate.css functionality
    if($('.round-w-buttons-inner').length) {
      $('.round-w-buttons-inner').each(function(key,val){
        var el = $(this);
        var bottom = el.position().top + el.outerHeight(true);
        scrollAdvance = 0
        if($(val).hasClass('complete-comfort')) scrollAdvance = 300
        var bottom = el.offset().top + el.outerHeight(true) - scrollAdvance
        if(screenBottom > bottom) {
            classes = 'zoomIn animated'
            setTimeout(function(){
                $('.icon1 img').addClass(classes)
                $('.left-content .content-single:nth-child(1)').addClass('opaque')
            },0)
            setTimeout(function(){
                $('.icon4 img').addClass(classes)
                $('.right-content .content-single:nth-child(2)').addClass('opaque')
            },500)
            setTimeout(function(){
                $('.icon2 img').addClass(classes)
                $('.right-content .content-single:nth-child(1)').addClass('opaque')
            },1000)
            setTimeout(function(){
                $('.icon3 img').addClass(classes)
                $('.left-content .content-single:nth-child(2)').addClass('opaque')
            },1500)
        }
      })
    }
    
    // Fade in items
    if($('.fade-delay').length) {
      $('.fade-delay').each(function(key,val){
        el = $(this);
        bottom = el.position().top + el.outerHeight(true);
        bottom = el.offset().top + el.outerHeight(true)
        if(screenBottom > bottom) {
          $(this).addClass('fade')
          setTimeout(function(){
            $('.fade-delay').removeClass('trans-delay')
          },1500)
        }
      })
    }
    
    // Slidein litter mask functionality
    if($('.gradient-animation-row').length) {
      $('.gradient-animation-row').each(function(key,val){
        el = $(this);
        elTop = el.position().top + (el.height() / 2)
        screenHeight = screenBottom - screenTop
        elAdjTop = elTop - screenTop
        halfHeight = screenHeight / 2
        if(elAdjTop > halfHeight && elAdjTop < screenHeight) {
          perc = ((1 - ((elAdjTop - halfHeight) / halfHeight)) * 100) - 20
          bgEle = $(this).find('.bg-container')
          $(bgEle).css('-webkit-mask-position',perc + 'vw')
        } else if(elAdjTop > 0 && elAdjTop < halfHeight) {
          bgEle = $(this).find('.bg-container')
          $(bgEle).css('-webkit-mask-position','95vw')
        }
      })
    }
    
    // Parallax functionality
    if($('.paraxify.trees').length) {
      $('.paraxify.trees').each(function(key,val){
        el = $(this);
        elTop = el.position().top + (el.height() / 2)
        screenHeight = screenBottom - screenTop
        elAdjTop = elTop - screenTop
        halfHeight = screenHeight / 2
        if(elAdjTop > -400 && elAdjTop < screenHeight + 400) {
          perc = ((1 - ((elAdjTop - halfHeight) / halfHeight)) * 100) + 50
          perc *= -0.5
          perc += 115
          $(this).css('background-position','center ' + perc + '%')
        }
      })
    }
    
  })
    
    if($('.product-section-area[data-section-title="crittercare"]').length) {
      $('.grid--collection.collections-main-area').append($('.product-section-area[data-section-title="crittercare"]'))
    }
    MicroModal.init({
      onClose: function(modal) {
        $(modal).find('.video-content iframe').remove()
      },
      onShow: function(modal) {
        videoOuter = $(modal).find('.video-content')
        iFrame = '<iframe class="maintain-aspect-ratio" width="' + $(videoOuter).data('width') + '" height="' + $(videoOuter).data('height') + '" src="' + $(videoOuter).data('url') + '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>'
        console.log(videoOuter)
        $(videoOuter).append(iFrame)
        $('.maintain-aspect-ratio:visible').height($('.maintain-aspect-ratio:visible').width() / ($('.maintain-aspect-ratio:visible').attr('width') / $('.maintain-aspect-ratio:visible').attr('height')))
      }
    });
  
    filters = [
        {
            sortOrder:1,
            filterOuter:"bedding",
            filterFull:"bedding_all-bedding",
            ele:''
        },
        {
            sortOrder:3,
            filterOuter:"bedding",
            filterFull:"bedding_crittercare®",
            ele:''
        },
        {
            sortOrder:2,
            filterOuter:"bedding",
            filterFull:"bedding_carefresh®",
            ele:''
        },
        {
            sortOrder:1,
            filterOuter:"litter",
            filterFull:"litter_all-litter",
            ele:''
        },
        {
            sortOrder:4,
            filterOuter:"litter",
            filterFull:"litter_puppy-go-potty™",
            ele:''
        },
        {
            sortOrder:3,
            filterOuter:"litter",
            filterFull:"litter_simply-pine™",
            ele:''
        },
        {
            sortOrder:2,
            filterOuter:"litter",
            filterFull:"litter_okocat®",
            ele:''
        }
    ]
    
    filters_colls = [
      'carefresh',
      'crittercare',
      'okocat',
      'simply-pine',
      'puppy-go-potty',
    ]
    $.each(filters_colls,function(key,val){
      $.each($('.product-section-area'),function(innerKey,innerVal){
      if($(innerVal).data('section-title') == val) {
        $('.collections-main-area').append(innerVal)
      }
      })
    })
  
    if($('.filter-body-outer').length) {
        $.each($('.single-filter-outer'),function(key,val){
            dataFilter = $(val).attr('data-filter-title')
            $.each(filters,function(filterKey,filterVal){
                if(filterVal.filterFull == dataFilter) {
                    filters[filterKey].ele = val
                }
            })
        })
        $('.single-filter-outer').remove()
        var i;
        $('.filter-group').attr('data-index',0)
    	for (i = 0; i < filters.length; i++) {
            $.each(filters,function(filterKey,filterVal){
                dataIndex = $('.filter-group[data-tag-prefix="' + filterVal.filterOuter + '"]').attr('data-index')
                if(filterVal.sortOrder == parseInt(dataIndex) + 1) {
            		$('.filter-group[data-tag-prefix="' + filterVal.filterOuter + '"]').append(filterVal.ele).attr('data-index',filterVal.sortOrder)
                }
            })
        }
    }
    
    setTimeout(function(){
      $('.product__price').removeClass('delay-display')
    },1000)
  
    function getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] == variable){return pair[1];}
      }
      return(false);
    }
    if(window.location.pathname == "/apps/store-locator/") {
      fVars = getQueryVariable('f')
      if(fVars != '') {
        fVars = fVars.split(',')
        $.each(fVars,function(key,paramVal){
          $.each($('.search_filter input[type="checkbox"]'),function(key,val){
            origText = $(this).parent().find('label').text()
            theSiblingText = $(this).parent().find('label').text()
            theSiblingText = theSiblingText.trim().replace('ö','o').replace(/(™)/i,'').replace(/(®)/i,'').replace(/ /i,'').replace(/ /i,'').replace(/ /i,'').toLowerCase()
            paramVal = paramVal.trim().replace('%c3%b6','o').replace("%e2%84%a2",'').replace("%c2%ae",'').replace("%20",'').replace("%20",'').replace("%20",'').toLowerCase()
            if(paramVal == theSiblingText) {
              $(this).prop('checked','checked')
            }
          })
        })
      }
    }

    var manageDisplayRetail = function(ourVariant) {
      $.each(variants, function(key,val){
        if(val.variantId == ourVariant) {
          $('.ext-ret-link').removeClass('display')
          if(val.retailers.length > 1) {
            $('.plural-retailer').show()
          } else {
            $('.plural-retailer').hide()
          }
          $('.payment-buttons').removeClass('hide-store hide-cart')
          if(val.isRetailerExc == '1') {
            $('.payment-buttons').addClass('hide-cart')
            $('.exclusively-available').show();
            $('.product__quantity,.product__price').removeClass('show');
            $('.retail-ext-header').text('This product is exclusively available through:')
          } else {
            $('.product__quantity,.product__price').addClass('show');
            $('.exclusively-available').hide();
            $('.retail-ext-header').text('Also available through:')
          }
          if(!val.isStoreExc) {
            $('.payment-buttons').addClass('hide-store')
          }
          if(!val.retailers.length) {
            $('.ext-ret-logos-row').hide()
          } else {
            $('.ext-ret-logos-row').show()
          }
          $.each(val.retailers, function(innerkey,innerval){
            $('.ext-ret-link[data-ext-ret="' + innerval.retailer + '"]').addClass('display').attr('href',innerval.url).attr('data-order',parseInt(innerval.key) + 1)
          })
          function sort_by_order(a, b){
            return ($(b).attr('data-order')) < ($(a).attr('data-order')) ? 1 : -1;
          }
          $(".ext-ret-links .ext-ret-link").sort(sort_by_order) // sort elements
          .appendTo('.ext-ret-links'); // append again to the list
        }
      })
    }
    if(typeof variants != 'undefined' && variants.length) {
      if(getQueryVariable('variant')) {
        manageDisplayRetail(getQueryVariable('variant'))
      } else {
        if(typeof defaultVariant != 'undefined') {
          manageDisplayRetail(defaultVariant)
        } else {
          manageDisplayRetail(defaultProduct)
        }
      }
    }
    $('.variant-input label:not(.disabled)').click(function(){
      setTimeout(function(){
        if(getQueryVariable('variant')) {
          console.log(getQueryVariable('variant'))
          manageDisplayRetail(getQueryVariable('variant'))
        }
      },50)
    })
    
    
  $('.filter-checkbox').click(function(){
        $('.filter-checkbox').attr('checked',false)
    checkMe = ($(this).is(':checked')) ? false : true
    $(this).parent().find('.filter-form-input').prop('checked',false)
    $(this).prop('checked',!checkMe)
    baseLink = $('.hidden-base-link a').attr('href')
    tagsArr = new Array();
      $.each($('.filter-checkbox:checked'),function(key,val){
      tagsArr.push($(val).data('tag-full'))
    })
    var query = tagsArr.join('+');
        console.log(query)
    window.location.href = baseLink.replace('/tag', '/' + query);
  })
    $('.view-all-filter').click(function(e){
        e.preventDefault()
    baseLink = $('.hidden-base-link a').attr('href')
    window.location.href = baseLink.replace('/tag', '/');
    })
    $.each($('.filter-checkbox'),function(key,val){
        if($(val).data('tag-full') == current_tags) {
      $(val).attr('checked','checked')
        }
    })
    $('.faq-single-container h3').click(function(){
        if($(this).hasClass('active')) {
            $(this).parent().find('p').slideUp('active')
            $(this).removeClass('active')
        } else {
            $('.faq-single-container').find('h3').removeClass('active')
            $('.faq-single-container').find('p').slideUp('fast')
            $(this).parent().find('h3').addClass('active')
            $(this).parent().find('p').slideDown('fast')
        }
    })
    if($("#slider-handle").length) {
      dragElement(document.getElementById("slider-handle"));
    }

    function dragElement(elmnt) {
      var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
      if (document.getElementById(elmnt.id + "header")) {
        // if present, the header is where you move the DIV from:
        document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
      } else {
        // otherwise, move the DIV from anywhere inside the DIV: 
        elmnt.onmousedown = dragMouseDown;
      }

      function dragMouseDown(e) {
        e = e || window.event;
        e.preventDefault();
        // get the mouse cursor position at startup:
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.onmouseup = closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag;
      }

      function elementDrag(e) {
        e = e || window.event;
        e.preventDefault();
        // calculate the new cursor position:
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
        // set the element's new position:
        width = document.getElementById('slider-inner').offsetWidth;
        sliderwidth = document.getElementById('slider-handle').offsetWidth;
        if((width - (sliderwidth / 2)) < elmnt.offsetLeft - pos1) {
          elmnt.style.left = (width - (sliderwidth / 2)) + "px";
          document.getElementById("slider-left").style.width = "100%"
        } else {
          if((-1 * sliderwidth / 2) > (elmnt.offsetLeft - pos1)) {
            elmnt.style.left = (-1 * sliderwidth / 2) + "px";
            document.getElementById("slider-left").style.width = "0px"
          } else {
            elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
            document.getElementById("slider-left").style.width = (elmnt.offsetLeft + (sliderwidth / 2)) + "px"
          }
        }
      }

      function closeDragElement() {
        // stop moving when mouse button is released:
        document.onmouseup = null;
        document.onmousemove = null;
      }
    }
  
})